<template>
  <div>
    <app-cells><h1 class="title">Database</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'ReservationDBDatabaseLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'hotels-database-list', label: 'Hotels' },
        { name: 'airlines-database-list', label: 'Airlines' },
      ],
    }
  },
}
</script>
